import { useEffect, useState } from 'react';

/** Reactive CSS media-query hook. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== 'undefined' && 'matchMedia' in window
      ? window.matchMedia(query).matches
      : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/**
 * Below Tailwind's `lg` (1024px) the app switches to the mobile shell:
 * drawer sidebar, bottom-sheet map panels, card lists, full-screen dialogs.
 * Keep this in sync with the `lg:` classes used across components.
 */
export const MOBILE_QUERY = '(max-width: 1023.98px)';
export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);

/** Coarse pointer = touch device (any width). */
export const useIsTouch = () => useMediaQuery('(pointer: coarse)');
